import React, {createContext, useCallback, useContext, useState} from "react";
import {useUtils} from "../../../../contexts";
import {Pages} from "../../../../bi-events/enum";

const MainMenuContext = createContext<MenuContextType | null>(null);

export interface MenuContextType {
  open: boolean;
  handleOpen: () => void;
  handleClose: () => void;
  trackAndCloseMenu: (cta: string) => void;
}

export const MainMenuProvider = ({children}: {children: React.ReactNode}) => {
  const {pageViewEvent, pageClickEvent} = useUtils();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    pageClickEvent({page: Pages.MENU, cta: "open_menu"});
    pageViewEvent({page: Pages.MENU});
    setOpen(true);
  };

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const trackAndCloseMenu = useCallback(
    (cta: string) => {
      pageClickEvent({page: Pages.MENU, cta});
      handleClose();
    },
    [pageClickEvent, handleClose]
  );

  const value = {
    open,
    handleOpen,
    handleClose,
    trackAndCloseMenu,
  };

  return <MainMenuContext.Provider value={value}>{children}</MainMenuContext.Provider>;
};

export const useConsumerMenu = () => {
  const ctx = useContext(MainMenuContext);
  if (!ctx) throw new Error("useConsumerMenu must be used within a MenuProvider");
  return ctx;
};
